<script setup>
import { computed } from 'vue'
import { Link, usePage } from '@inertiajs/vue3'
import { CreditCard, ArrowRight } from 'lucide-vue-next'

const page = usePage()
const isTeacher = computed(() => page.props.auth?.user?.user_type === 'teacher')
const stripeConnectStatus = computed(() => page.props.stripeConnectStatus)

const bannerColor = computed(() => {
  if (stripeConnectStatus.value === 'restricted') return 'bg-red-600 hover:bg-red-700'
  return 'bg-amber-500 hover:bg-amber-600'
})

const message = computed(() => {
  if (stripeConnectStatus.value === 'restricted') {
    return 'Your Stripe account is set up but payouts are not enabled — please complete any outstanding Stripe requirements.'
  }
  if (stripeConnectStatus.value === 'pending_verification') {
    return 'Your Stripe verification is incomplete — you won\'t be able to receive payouts until this is resolved.'
  }
  return 'Connect your Stripe account to start receiving payouts from your lessons.'
})
</script>

<template>
  <Link
    v-if="isTeacher && stripeConnectStatus && stripeConnectStatus !== 'active'"
    href="/teacher/settings/bank-details"
    :class="[bannerColor, 'text-white px-4 py-2 flex flex-col md:flex-row md:items-center md:justify-center gap-3 text-sm font-medium z-50 relative transition-colors']"
  >
      <div class="flex items-center gap-2">
    <CreditCard class="h-4 w-4 shrink-0" />
    <span>{{ message }}</span>
      </div>
    <span class="inline-flex self-start items-center gap-1 bg-white/20 hover:bg-white/30 rounded-full px-3 py-0.5 text-xs font-semibold transition-colors">
      Set up now
      <ArrowRight class="h-3 w-3" />
    </span>
  </Link>
</template>
